import { action, observable, makeObservable } from 'mobx';
export class SortStore {
    constructor(sortBy) {
        Object.defineProperty(this, "sortBy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this, {
            sortBy: observable,
            setSortBy: action,
        });
        this.sortBy = sortBy;
    }
    sort(objects) {
        if (this.sortBy === undefined) {
            return objects;
        }
        return objects.slice().sort(this.sortBy);
    }
    setSortBy(sortBy) {
        this.sortBy = sortBy;
    }
}
//# sourceMappingURL=SortStore.js.map